// Fullpage module conflicts with HTML anchor link
// This module helps to fix this issue
// It simulates scroll to anchor but used data attribute instead id

export const scrollToAnchor = () => {
    $('.anchor-link').on('click', (e) => {
        const anchorSection = ($(e.target).attr('href')).substr(1);

        $([document.documentElement, document.body]).animate({
            scrollTop: $('*[data-anchor="' + anchorSection + '"]').offset().top
        }, 500);
    });
}
